<template>
    <el-row :gutter="30"  class="mw-100 manage-footerContact" >
        
        <el-col :lg="24" :xs="24">
            
            <el-card>
                <el-form
                    class="text-center font-24" 
                    ref="addParentFooterContactRef"
                    :model="currentFooterContactData"
                    :rules="currentFooterContactDataRules"
                    label-position="top"
                >
                    <el-row :gutter="30">
                        <el-col :lg="24" :xs="24">
                            <el-form-item>
                                <el-button type="primary" @click="manageFooterContact('addFooterContactRef')" class="text-cap">
                                    <font-awesome-icon :icon="['fas', 'floppy-disk']" style="width:20px" class="mr-10" />
                                    save
                                </el-button>
                            </el-form-item>
                        </el-col>
                        <el-col :lg="3" :xs="24">
                            <el-form-item label="Type" prop="contactType">
                                <el-select v-model="currentFooterContactData.contactType">
                                    <el-option v-for="(type, index) in types" :key="index"  :label="type" :value="type"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        
                    </el-row>
                </el-form>
                <el-tabs  tab-position="left">
                    <el-tab-pane  v-for="(item, index) in currentFooterContactData.translates" :key="index" >
                        <template #label>
                            <span class="custom-tabs-label">
                                <span>
                                    {{$getLanguageName(item.languageID)}}
                                </span>
                            </span>
                        </template>
                        <el-form 
                            class="text-center font-24" 
                            ref="addFooterContactRef"
                            :model="currentFooterContactData"
                            :rules="currentFooterContactDataRules"
                            label-position="top"
                        >
                            <el-row :gutter="30">
                               
                                <el-col :lg="24" :xs="24">
                                    <el-form-item  label="contact value" :prop="`translates[${index}].title`" :class="$getLanguageName(item.languageID).toLowerCase() == 'عربي' ? 'text-right':''">
                                        <el-input type="text" v-model="currentFooterContactData.translates[index].title"></el-input>    
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                    </el-tab-pane>
                </el-tabs>
            </el-card>
        </el-col>
    </el-row>
    
</template>

<script>
export default {
    data(){
        return {
            isAddFooterContact:true,
            currentFooterContact:[],
            fileList:[],
            dialogVisible:false,
            dialogImageUrl:'',
            fileUploaded:false,

            currentFooterContactData:{},
            types:[
                'email',
                'address',
                'phone'
            ],
            currentFooterContactDataRules:{
                contactType:{
                    required:true,
                    message:'required field',
                    trigger:'blur',
                },
                translates:this.$setTranslateRules(['title']),
            }
        };
    },
    computed:{
        cachedFooterContact(){
            return JSON.parse(localStorage.getItem('adminStore'))?.website?.careers?.footerContacts.currentFooterContact || {}
        }
    },
    mounted(){
        if (this.$route.params.id && this.$route.params.id == this.cachedFooterContact.id) {
            this.isAddFooterContact = false;
            this.currentFooterContactData = JSON.parse(JSON.stringify(this.cachedFooterContact))
            this.currentFooterContactData.translates = this.$filterPublishedTranslates(this.currentFooterContactData.translates)
        }else{
            this.$router.push({
                name:'manage-footer-contact',
            })
            
            this.isAddFooterContact = true;
            this.currentFooterContactData = this.initState()
        }
    },
    
    methods:{
        initState(){
            return {
                contactType:'',
                translates:this.$setTranslateKeys({
                    'title':''
                })
            }
        },
       
        async manageFooterContact(formName){
            let successForm = [];
            this.$refs['addParentFooterContactRef'].validate(async (parentValid) => {
                if (parentValid) {
                    for (let index = 0; index < this.$refs[formName].length; index++) {
                        const element = this.$refs[formName][index];
                        element.validate(async (valid) => {
                            if (!valid) {
                                this.$message({
                                    message:`please fill the data in the ${this.$getOrderName(index + 1)} tab `,
                                    type:'info',
                                    duration:5000,
                                    showClose: true,
                                });
                            }
                        }).then(data =>{
                            let indexOfIndex = successForm.indexOf(index);
                            if (data){
                                successForm.push(index);
                                if (successForm.length == this.$refs['addFooterContactRef'].length){
                                    this.manageFooterContactAfterValidate()
                                }
                            }else{
                                if(indexOfIndex != -1) {
                                    successForm.splice(indexOfIndex,1);
                                }
                            }
                        })  
                    }
                }else{
                    return false
                }
            })
            
        },
        async manageFooterContactAfterValidate(){
            
            const response = await this.$store.dispatch(this.isAddFooterContact ? 'addFooterContact':'updateFooterContact',this.currentFooterContactData);
            if (response?.data?.status == 1) {
                this.$notify({
                    title:String(response.status),
                    message:response.data.message,
                    type:'success',
                });
                await this.$store.dispatch('getFooterContact');
                this.$router.push({
                    name:'footer-contacts-list'
                })
            }
        },
    }
}
</script>
<style lang="scss">
    .manage-footerContact {
        .ck-editor {
            width:100%;
        }
    }
</style>